import { Grid, Typography } from '@mui/material';
import ReferenceDataKey from 'helpers/enums/ReferenceDataKey';
import { applicationContext } from 'helpers/services';
import { useContext } from 'react';
import { orderContext } from '../OrderContext';
import { DetailsPageHeader } from 'components';


let Channel = () => {
    let appService = useContext(applicationContext);
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='Channel'>
            <Grid container>
                <Grid item xs={3}>
                    <Typography>Type</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{service.order.channelType}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Code</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{service.order.channelCode}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Description</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{appService.referenceData[ReferenceDataKey.Channel].getValueByKey(service.order.channelCode) ?? ""}</Typography>
                </Grid>
            </Grid>
        </DetailsPageHeader>
    );
}

export default Channel;